import React, { useState, useEffect } from "react";
import "../styles/topbar.css";

const Topbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  const handleNavigation = (id) => {
    closeMenu();
    const target = document.getElementById(id);
    if (target) {
      const topbarHeight = document.querySelector('.topbar').offsetHeight;
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - topbarHeight;
      window.scrollTo({
        top: targetPosition,
        behavior: "smooth"
      });
    }
  };

  useEffect(() => {
    const handleScroll = () => setIsSticky(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`topbar ${isSticky ? "sticky" : ""}`}>
      <div className="topbar-container">
        <nav className={`topbar-nav ${isMenuOpen ? "open" : ""}`}>
          {["About", "Experience", "Projects", "Skills", "Education", 
            "Certificate", "Languages","FAQ"].map((item) => (
            <a
              key={item}
              href={`#${item.toLowerCase()}`}
              className="topbar-link"
              onClick={(e) => {
                e.preventDefault();
                handleNavigation(item.toLowerCase());
              }}
            >
              {item}
            </a>
          ))}
        </nav>
        <button
          className="menu-toggle"
          onClick={toggleMenu}
          aria-label="Toggle navigation"
          aria-expanded={isMenuOpen}
        >
          {isMenuOpen ? "✕" : "☰"}
        </button>
      </div>
    </header>
  );
};

export default Topbar;